module.exports = __webpack_public_path__ + "img/avatar.6346e7c5.png";